export default __webpack_public_path__ + "static/media/admin_product_reports_active.c2ea1410.svg";